import React from 'react'
import { useNavigate } from 'react-router-dom'
import toast from 'react-hot-toast'
import Footer from './Footer'

const OTPVerification = () => {
  const BASE_URl = window.location.origin
  const navigate = useNavigate()
  const handleLogin = (e) => {
    e.preventDefault()
    const formData = {
      verificationCode: e.target.code.value,
    }
    
    fetch(`${BASE_URl}/api/verifyCode`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)

    }).then((res) => res.json())
    .then((data) => {
      if(data && data.sucess === true) {
        toast.success(data.message)
        navigate('/auth/login')
      } else if(data && data.sucess === false) {
        toast.error(data.message)
      }
    })
    .catch((error) => {
      if (error) {
        toast.error(error.message || 'Internal Server Error')
      }
    })

    e.target.reset()
  }


  return (
    <>
    <div className='mt-24 flex flex-col items-center h-[80vh] pb-14'>
      <h1 className='text-center mb-8 text-3xl font-serif '>Verify Code</h1>
      <form onSubmit={handleLogin} className='flex flex-col items-center justify-evenly gap-2 w-[90%] h-[90%] bg-blue-300 p-3 rounded-[10px] sm:w-[80%] lg:w-[70%]'>
        <input required type="text" placeholder='OTP' name="code" maxLength={6} className='text-center border-[0.5px] p-3 outline-0 rounded-[8px] w-[60%] active:bg-none placeholder:text-black'/>
        <div className='w-[80%] flex justify-evenly'>
          <button type='reset' className='cursor-pointer border-[0.5px] p-3 rounded-2xl hover:bg-blue-200' style={{transition: '0.5s'}}>Reset</button>
          <button type='submit' className='cursor-pointer border-[0.5px] p-3 rounded-2xl bg-blue-200 hover:bg-blue-300' style={{transition: '0.5s'}}>Verify</button>
        </div>
      </form>

    </div>
    <Footer/>
    </>
  )
}

export default OTPVerification
 